export default {
      id: "ic_accessibilite-usage",
      viewBox: "0 0 35 35",
      url: "../dist/images/" + "sprite.svg#ic_accessibilite-usage",
      toString: function () {
        return this.url;
      }
    }